export type BreadcrumbJsonLdItem = {
  name: string;
  path: string;
};

const SITE_ORIGIN = "https://sbdcl.biz";

/**
 * パンくずリストのBreadcrumbList構造化データ（JSON-LD）。
 * 表示しているパンくずと、階層・名称・URLを一致させる。
 */
export default function BreadcrumbJsonLd({ items }: { items: BreadcrumbJsonLdItem[] }) {
  const data = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.name,
      item: `${SITE_ORIGIN}${item.path}`,
    })),
  };

  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }} />;
}